<template>
  <va-create-layout>
    <form-form :title="title" :item="item"></form-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
